module.exports = __webpack_public_path__ + "media/images/emblems/Bassins-coat_of_arms-c7a31c3b2aac34c3a0df8380d9810a34.svg";